import { render, staticRenderFns } from "./RefundTradeModal.vue?vue&type=template&id=4d5265ee"
import script from "./RefundTradeModal.vue?vue&type=script&lang=js"
export * from "./RefundTradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports